const text = value => String(value ?? '').trim();

export const initialConversationDraft = () => ({
  key: '',
  projectId: '',
  revision: 0,
  status: 'idle',
});

const activateDraft = (current, event) => {
  const projectId = text(event.projectId);
  if (!projectId) return current;
  if (current.status === 'active' && current.projectId === projectId) return current;
  const revision = current.revision + 1;
  return { key: `${projectId}:${revision}`, projectId, revision, status: 'active' };
};

const clearDraft = (current) => (
  current.status === 'idle'
    ? current
    : { ...initialConversationDraft(), revision: current.revision }
);

const TRANSITIONS = new Map([
  ['activate', activateDraft],
  ['clear', clearDraft],
]);

export const resolveConversationDraft = (state, event = {}) => {
  const current = state ?? initialConversationDraft();
  const transition = TRANSITIONS.get(event.type);
  return transition ? transition(current, event) : current;
};
